export default "__VITE_ASSET__bs3cT6h6__"